import React from 'react';
import { EVENT_NOTIFICATION_TYPE } from "../../helpers/EventNotificationType";
import { EaseIn } from "../../helpers/animations/EaseIn";
import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Cancel";
import DoneIcon from "@mui/icons-material/Done";
import { Nullable } from '../../models/common/Nullable';
import { Hideable } from '../../models/common/ViewSettings';

interface EventNotificationBarProps extends Hideable {
    messageType: EVENT_NOTIFICATION_TYPE
    message: string
}

function EventNotificationBar ({ messageType, message, isVisible }: EventNotificationBarProps) {
    let component: Nullable< React.ReactNode > = null;
    const animation = { animate: EaseIn() } as React.CSSProperties;

    if( isVisible ) {
        switch (messageType) {
            case EVENT_NOTIFICATION_TYPE.ajaxSuccess:
                component =
                    <div id="event-notification-bar" style={animation} className="success green">
                        <DoneIcon/>Eintrag erfolgreich gespeichert
                    </div>;
                break;
            case EVENT_NOTIFICATION_TYPE.ajaxFailure:
                component =
                    <div id="event-notification-bar" style={animation} className="error red">
                        <CancelIcon/> Eintrag konnte nicht gespeichert werden
                    </div>;
                break;
            case EVENT_NOTIFICATION_TYPE.customAjaxError:
                component =
                    <div id="event-notification-bar" style={animation} className="error red"><i className="fa fa-times-circle"/>
                        <CancelIcon/> {message}
                    </div>;
                break;
            case EVENT_NOTIFICATION_TYPE.notification:
                component =
                    <div id="event-notification-bar" style={animation} className="standard-notification">
                        <InfoIcon /> {message}
                    </div>;
                    break;
            default:
                component = null;
        }
    } else {
        component = null;
    }

    return (
        <div>
        {component}
        </div>
    );
}

export default EventNotificationBar;